import { css } from '@emotion/core';
import theme from '../../themes/default';
import styleUtils from '../../styles/utils';

const badge = ({ color = theme.color.designSystem.success } = {}) => css`
  ${styleUtils.flex.container({ inline: true })};
  ${styleUtils.base.square({ size: '16px' })};
  border-radius: ${theme.borderRadius.large};
  background-color: ${color};
  vertical-align: middle;
`;

const badgeWithCount = css`
  width: 24px;
`;

const count = css`
  ${styleUtils.typography.small({ weight: 'semiBold' })};
  color: ${theme.color.white};
`;

export default {
  badge: {
    base: badge,
    withCount: badgeWithCount,
  },
  count: {
    base: count,
  },
};
